/* eslint-disable complexity */

import React, { useEffect } from 'react';

import { useExperience } from '@unisporkal/experiences';
import acquisitionTypes from '../../../support/acquisitionTypes.ts';
import BatchSize from './Sizes/BatchSize';
import ImageSize from './Sizes/ImageSize';
import FilmSize from './Sizes/FilmSize.tsx';
import LicenseSize from './Sizes/LicenseSize';

import styles from './AssetSizes.module.scss';
import useSelectedIndex from '../../../hooks/stateful/useSelectedIndex.ts';
import { useAsset } from '../../../hooks/stateful/useAsset';
import { useAcquisitionType } from '../../../hooks/stateful/useAcquisitionType.ts';
import updateABTestVariation from '../../../utils/updateABTestVariation';
import useOnLoad from '../../../hooks/queries/useOnLoad';

const AssetSizes = () => {
  const { asset } = useAsset();
  const { acquisitionType } = useAcquisitionType();
  const { response: { config: { options } = {} } = {} } = useOnLoad();
  const { selectedOptionIndex = 0 } = useSelectedIndex();
  const selectedOption =
    options?.length > 0 ? options[selectedOptionIndex] : null;

  const experience = useExperience('gettyAlcPriceSimplificationTest');
  const gettyAlcPriceSimplificationOffer = experience.activeOffer('test');

  const gettyAlcPriceSimplificationVariation =
    gettyAlcPriceSimplificationOffer &&
    !asset.isRightsReady() &&
    acquisitionType === acquisitionTypes.LICENSE
      ? `gettyalcpricesimplificationtest-${gettyAlcPriceSimplificationOffer}`.toLowerCase()
      : null;

  useEffect(() => {
    if (gettyAlcPriceSimplificationVariation) {
      updateABTestVariation(gettyAlcPriceSimplificationVariation);
    }
  }, [gettyAlcPriceSimplificationVariation]);

  const getSizeDisplay = (size, index) => {
    if (acquisitionType === acquisitionTypes.BATCH_DOWNLOAD) {
      return (
        <BatchSize
          key={size.name}
          size={size}
          index={index}
        />
      );
    }
    if (size.license) {
      return (
        <LicenseSize
          key={size.license}
          size={size}
          index={index}
        />
      );
    }
    if (asset.isFilm()) {
      return (
        <FilmSize
          key={size.name}
          size={size}
          index={index}
        />
      );
    }
    return (
      <ImageSize
        key={size.name}
        size={size}
        index={index}
      />
    );
  };

  if (!selectedOption?.sizes?.length) return null;

  return (
    <div
      className={styles.table}
      data-testid="asset-sizes"
      key="assetSizes"
    >
      {selectedOption.sizes.map((size, index) => getSizeDisplay(size, index))}
    </div>
  );
};

export default AssetSizes;
